import React, { useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import styled from "styled-components"
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import { colors } from "../../utils/theme"
import { device } from "../../utils/breakpoints"
import IconList from "../../images/list-icon.svg"
import Modal from "react-bootstrap/Modal"
import FormDudas from "../temario/FormDudas"

//components
import Amateurs from "./Amateurs"
import Pros from "./Pros"

const PremiosContent = styled.section`
  position: relative;
  & .premios-title {
    position: absolute;
    top: 0rem;
    left: 0;
    text-align: center;
    color: white;
    width: 100%;
    z-index: 1;
    & span {
      padding: 0.3em 1em;
      border: 2px solid white;
      background: ${colors.pColor};
      color: ${colors.sColor};
      font-weight: 600;
    }
  }
  & .row-rules {
    position: relative;
  }
  & .col-rules {
    & a {
      color: ${colors.sColor};
    }
    & h2 {
      font-weight: 600;
      color: white;
      margin: 4rem 0 2rem 0;
      position: relative;
      & strong {
        font-weight: 800;
      }
      & span {
        position: absolute;
        bottom: 160%;
        left: 15px;
        &::after {
          content: "";
          border-radius: 100%;
          border: 2px solid white;
          width: 60px;
          height: 60px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
    & ul {
      margin: 0;
      padding: 0;
      & li {
        margin-bottom: 0.5rem;
        color: white;
        font-size: 0.8em;
        list-style: none;
        position: relative;
        &::before {
          content: "";
          left: -20px;
          top: 5px;
          width: 10px;
          height: 10px;
          position: absolute;
          background: url(${IconList});
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
    }
    &--one {
      @media ${device.lg} {
      }
    }
    &--two {
      @media ${device.lg} {
      }
    }
  }
  .button {
    border: 0;
    padding: 5px 10px;
    border-radius: 10px;
    margin-right: 7px;
    &-drive {
      background: ${colors.sColor};
      color: ${colors.pColor};
    }
    &-register {
      background: white;
      color: ${colors.pColor};
      font-weight: 700;
      &:hover {
        background: ${colors.sColor};
        color: ${colors.pColor};
      }
    }
  }
`

export default function Premios() {
  const [modalForm, setModalForm] = useState(false)
  const { backgrounds } = useStaticQuery(graphql`
    query {
      backgrounds: allFile(
        sort: { fields: name, order: ASC }
        filter: { name: { regex: "/rules/" } }
      ) {
        edges {
          node {
            base
            childImageSharp {
              fluid(quality: 70, maxWidth: 200) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
  `)
  const { edges } = backgrounds

  return (
    <PremiosContent id="premios">
      <Container fluid={true} className="p-0">
        <Row noGutters={true} className="row-rules">
          <Col md={12}>
            <h2 className="premios-title">
              <span>Premios</span>
            </h2>
          </Col>
          <Col lg={6} className="">
            <Amateurs />
          </Col>
          <Col lg={6} className="">
            <Pros />
          </Col>
        </Row>
      </Container>
      <Modal
        show={modalForm}
        onHide={() => setModalForm(false)}
        aria-labelledby="example-modal-sizes-title-sm"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <FormDudas />
        </Modal.Body>
      </Modal>
    </PremiosContent>
  )
}
